import React from "react";
import { connect } from "react-redux";
import { getUsersByCompanyId } from "../Planes/actions";
import SelectField from "../../Shared/fields/SelectField";

import {
  editarPlanMovilidadEncargado,
  editarPlanMovilidadEncuesta,
  escogerTiposUsuariosRiesgosPlanMovilidad,
  onAlertaPlanMovilidad,
  handlerTokenEncuesta } from "../Planes/actions";
import { getNombreEncargado, dataLayerTag } from "../Planes/functions";
import Loading from "../Util/Loading";

class AdministracionItem extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      rutEncargado: props.data.rutusuario,
      nombreEncargado: props.data.nombreusuario,
      emailEncargado: props.data.emailusuario,
    };
  }

  componentDidMount(){
    const { isEmployeesLoaded, dispatch, companyId } = this.props;
    if ( !isEmployeesLoaded ){
      dispatch(getUsersByCompanyId(companyId));
    }
  }

  handleChange = (e) => {
    switch (e.element.id) {
      case "encargadoPlanMovilidad":
          const nuevoEncargado = getNombreEncargado(this.props.employees, e.value);
          this.setState({ rutEncargado: e.value, nombreEncargado: nuevoEncargado.nombre, emailEncargado: nuevoEncargado.email });
        break;
    }
  }

  handlerEditarEncargado = () => {
    this.props.dispatch(editarPlanMovilidadEncargado(this.props.data.idplanMovilidad, this.state.rutEncargado, this.state.nombreEncargado, this.props.usuarioRUT))
  }

  closeEncuestaTrabajadorForce = () => {
    const {
      dispatch,
      encuestaHombres,
      encuestaMujeres,
      idplanMovilidad,
      cantidadHombresCentro,
      cantidadMujeresCentro,
      fechaCierreEncuestaTrabajador,
    } = this.props;

    if ( encuestaHombres + encuestaMujeres > 0){
      // fuerzo el cierre de la encuesta, me da lo mismo si hay o no información
      dispatch(handlerTokenEncuesta(false));
      dispatch(editarPlanMovilidadEncuesta(
        idplanMovilidad,
        false, // habilitarTokenEncuesta,
        cantidadHombresCentro,
        cantidadMujeresCentro,
        fechaCierreEncuestaTrabajador,
      ));
      dispatch(onAlertaPlanMovilidad("success", "Se cerró la encuesta forzosamente."));
      dataLayerTag({
        'event': 'paso_2_finaliza_encuesta_trabajadores',
        'tipo_encuesta_finalizada': 'forzada',
      });
      // cálculo de riesgos y tipos de usuarios
      dispatch(escogerTiposUsuariosRiesgosPlanMovilidad(idplanMovilidad));
    } else {
      dispatch(onAlertaPlanMovilidad("error", "Debe tener al menos UNA encuesta respondida"));
    }
  }

  render() {
    const {employees, estadoProceso, isEmployeesLoaded} = this.props;
    const {rutEncargado} = this.state;
    return (
      <section id="content-etapa">
        {!isEmployeesLoaded && <Loading />}
        <div className="container-fluid">
          <div className="row PM-plan-borde-spacing">
            <div className="col-md-12 text-left PM-plan-contador-tareas PM-home-item-plan">
              <div className="col-md-12 pt-10">
                <SelectField
                  id="encargadoPlanMovilidad"
                  label="Encargado"
                  value={rutEncargado}
                  onChange={this.handleChange}
                  items={employees? employees : []}
                  displayExpr="EmployeeName"
                  valueExpr="Rut"
                />
              </div>
              <div className="col-md-12 row pt-10">
                <div className="col-md-8">&nbsp;</div>
                <div className="col-md-4">
                  <button className="btn PM-dx-button-plan PM-dx-button-plan-100" onClick={this.handlerEditarEncargado}>Asignar nuevo responsable</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="btn-box row" style={{ marginTop: 10 }}>
          <div className="col-md-8">&nbsp;</div>
          <div className="col-md-4 text-left">
            <button
              className="btn PM-dx-button-plan PM-dx-button-plan-40"
              onClick={this.closeEncuestaTrabajadorForce}
              disabled={ estadoProceso !== 2 }
            >Forzar cierre de encuesta trabajador</button>
          </div>
          
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  companyId: state.global.companyId,
  employees : state.planMovilidad.employees,
  isEmployeesLoaded: state.planMovilidad.isEmployeesLoaded,
  usuarioRUT: state.global.userData.RUT,
  estadoProceso: state.planMovilidad.estadoProceso,
  estadoTokenEncuesta: state.planMovilidad.estadoTokenEncuesta,
  idplanMovilidad: state.planMovilidad.idplanMovilidad,
  cantidadHombresCentro: state.planMovilidad.cantidadHombresCentro,
  cantidadMujeresCentro: state.planMovilidad.cantidadMujeresCentro,
  fechaCierreEncuestaTrabajador: state.planMovilidad.fechaCierreEncuestaTrabajador,
  encuestaHombres: state.planMovilidad.encuestaHombres,
  encuestaMujeres: state.planMovilidad.encuestaMujeres,
  state,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(AdministracionItem);
